export const environment = {
  production: false,
  envName: "dev",
  autoSignIn: true,
  popupForLogin: false,
  cacheLocation: "localStorage",
  instance: "https://login.microsoftonline.com/",
  tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  clientId: '7dc2c97b-0052-4f5a-bba4-2f7d208c6dbe',
  redirectUri: 'https://ecash-app-dev.azure.chevron.com',
  oidcScopes: ["openid", "profile", "User.Read","offline_access"],
  graphScopes: ["User.Read", "User.Read.All"],
  apiUrl: 'https://ecash-api-dev.azure.chevron.com/api/v1',
  graphApiURL: 'https://graph.microsoft.com'
};